import type { FunnelConversationDocument } from 'src/api/generated';

export const TEST_ADDRESS_PREFIX = 'test:';

export const isTestAddress = (address?: string | null): boolean => {
  return typeof address === 'string' && address.startsWith(TEST_ADDRESS_PREFIX);
};

export const isTestConversationDocument = (
  conversation?: FunnelConversationDocument | null
): boolean => {
  return (
    conversation?.contacts?.some((contact) =>
      contact.addresses?.some((address) => isTestAddress(address.address))
    ) ?? false
  );
};
